import { render, staticRenderFns } from "./Kidzwonder.vue?vue&type=template&id=096b71e2"
import script from "./Kidzwonder.vue?vue&type=script&lang=js"
export * from "./Kidzwonder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports